import { BrowserRouter as Router, Route, Routes, NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const ContactSupport = () => {
	const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(
    	<>
    		<div className="thankyou_msg">Submitting....</div>
    	</>
    );

    try {
      const resp = await fetch("https://coinmediaworld.com/admin/api/submit-form", {
	      method: "POST",
	      headers: {
	        "Content-Type": "application/json",
	        // Add authorization headers here if your API requires them
	      },
	      body: JSON.stringify(formData),
	    });

	    if (!resp.ok) {
	      const msg = await resp.text();
	      throw new Error(`${resp.status} ${resp.statusText} — ${msg}`);
	    }
	    else {
	    	setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "" });
	    	setStatus(
				  <>
				  	<div className="thankyou_msg">
				    <b>Thank You for Reaching Out Coinviews!</b>
				    <p>
				      We’ve received your message and our team will get back to you shortly.<br />
				      In the meantime, stay ahead of the curve <a
				        href="https://t.me/coinviews144"
				        target="_blank"
				        rel="noopener noreferrer"
				      >join our Telegram channel</a> for the latest market insights, crypto news, and trading signals.
				    </p>
				    </div>
				  </>
				);
	    }
    } catch (error) {
      console.error("Error submitting form:", error);
      setStatus(
      	<>
      	<div className="thankyou_msg">
      	❌ Failed to send message. Please try again.
      	</div>
      	</>
      );
    }
  };

  return (
	<div className="contactsupport_wrapper">
		<div className="otherpage_banner" style={{ backgroundImage: `url(${homeUrl}/assets/img/contact-us-banner.jpg)`,}}>
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="toptitlebox">
							<div className="breadcrumb_mainsec">
								<ul>
									<li><a href="#">Home</a></li>
									<li><span>Contact Support</span></li>
								</ul>
							</div>
							
							<div className="titlesec">
								<h2>Contact Support</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
			
		<div className="contact_mainsec">
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
						<div className="form_mainsec">
							<form onSubmit={handleSubmit}>
					      <div className="row">
					        <div className="col-sm-12 col-md-6">
					          <div className="form-group">
					            <label className="form-label">First Name</label>
					            <input
					              type="text"
					              className="form-control"
					              placeholder="First Name"
					              name="firstName"
					              value={formData.firstName}
					              onChange={handleChange}
					              required
					            />
					          </div>
					        </div>

					        <div className="col-sm-12 col-md-6">
					          <div className="form-group">
					            <label className="form-label">Last Name</label>
					            <input
					              type="text"
					              className="form-control"
					              placeholder="Last Name"
					              name="lastName"
					              value={formData.lastName}
					              onChange={handleChange}
					              required
					            />
					          </div>
					        </div>

					        <div className="col-sm-12 col-md-6">
					          <div className="form-group">
					            <label className="form-label">Email Address</label>
					            <input
					              type="email"
					              className="form-control"
					              placeholder="Email Address"
					              name="email"
					              value={formData.email}
					              onChange={handleChange}
					              required
					            />
					          </div>
					        </div>

					        <div className="col-sm-12 col-md-6">
					          <div className="form-group">
					            <label className="form-label">Phone Number</label>
					            <input
					              type="tel"
					              className="form-control"
					              placeholder="Phone Number"
					              name="phone"
					              value={formData.phone}
					              onChange={handleChange}
					              required
					            />
					          </div>
					        </div>

					        <div className="col-sm-12">
					          <div className="form-group">
					            <label className="form-label">Message</label>
					            <textarea
					              className="form-control"
					              rows="5"
					              placeholder="Message"
					              name="message"
					              value={formData.message}
					              onChange={handleChange}
					              required
					            ></textarea>
					          </div>
					        </div>

					        <div className="col-sm-12">
					          <div className="btn_mainsec">
					            <button type="submit" className="btn_style">
					              Submit
					            </button>
					          </div>
					          {status && <p>{status}</p>}
					        </div>
					      </div>
					    </form>
						</div>
					</div>
					
					<div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
						<div className="contnt_box">
							<div className="title_box">
								<h2>Get In Touch</h2>
							</div>
							
							<div className="info_box">
								<ul>
									<li>
										<div className="iconbox">
											<a href="mailto:hello@cionviews.com">
												<img src={`${homeUrl}/assets/img/mail_icon.png`} />
											</a>
										</div>
										
										<div className="icontxt">
											<p>hello@cionviews.com</p>
										</div>
									</li>
									
									<li>
										<div className="iconbox" bis_skin_checked="1">
											<a href="https://t.me/vb144" target="_blank">
												<img src={`${homeUrl}/assets/img/telegram-icon.png`} />
											</a>
										</div>
										
										<div className="icontxt" bis_skin_checked="1">
											<p>DM for Priority support!</p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
  );
};

export default ContactSupport;